import { API, graphqlOperation } from 'aws-amplify';
import { listLicenceMaintenanceHistories as ListLicenceMaintenanceHistories } from './queries';

/**
 * 保守期限変更履歴を、owner & 期間 & （任意）userId によって取得するヘルパー。
 *
 * @param {Object} params
 * @param {string} params.owner    - 履歴の owner（Cognito の username など）
 * @param {string} params.from     - 期間開始（ISO文字列）
 * @param {string} params.to       - 期間終了（ISO文字列, 非包含）
 * @param {string[]} [params.myUserIds] - 自分が管理する User.id の配列（指定すると userId で絞り込み）
 * @param {number} [params.pageLimit]   - 1ページあたりの取得件数（デフォルト500）
 * @returns {Promise<Array>}  条件にマッチした LicenceMaintenanceHistory の配列
 */
export async function fetchMaintenanceHistories({
  owner,
  from,
  to,
  myUserIds = [],
  pageLimit = 500,
}) {
  const hasUserFilter = Array.isArray(myUserIds) && myUserIds.length > 0;
  const userIdSet = hasUserFilter ? new Set(myUserIds) : null;

  let allHistories = [];
  let nextToken = null;
  let first = true;

  while (first || nextToken) {
    first = false;

    const resp = await API.graphql(
      graphqlOperation(ListLicenceMaintenanceHistories, {
        filter: {
          owner: { eq: owner },
          createdAt: { between: [from, to] },
        },
        limit: pageLimit,
        nextToken,
      })
    );

    const page = resp?.data?.listLicenceMaintenanceHistories;
    const items = page?.items ?? [];

    const filteredItems = hasUserFilter
      ? items.filter((h) => h.userId && userIdSet.has(h.userId))
      : items;

    allHistories = allHistories.concat(filteredItems);
    nextToken = page?.nextToken ?? null;

    if (!nextToken) break;
  }

  return allHistories;
}
